/**
 * "This phone can render question X now."
 *
 * A module-level box rather than state or context, deliberately. The signal is
 * produced deep in QuestionScreen (body decrypted, media decoded) and consumed
 * by the poll in PlayerApp, and routing it through React would mean either
 * prop-drilling through four components or a context whose every change
 * re-renders the question mid-countdown.
 *
 * The same reasoning as the home page's "already alerted" set living in a ref:
 * a value the render does not depend on should not be state.
 */
let readyFor: string | null = null;
let reported: string | null = null;

/** Called when the question is genuinely renderable -- media included. */
export function markReady(questionId: string): void {
  if (readyFor !== questionId) {
    readyFor = questionId;
    reported = null;
  }
}

/**
 * What the next poll should carry, or null.
 *
 * Returns a question id once and then stops. 75 phones polling every two
 * seconds would otherwise be 37 writes a second to say something the server
 * already knows, all of them refused by the unique constraint.
 */
export function takeReadySignal(): string | null {
  if (!readyFor || readyFor === reported) return null;
  reported = readyFor;
  return readyFor;
}

/** A poll that failed should try again rather than swallow the report. */
export function unreportReady(): void {
  reported = null;
}

/** Leaving the event. */
export function clearReadySignal(): void {
  readyFor = null;
  reported = null;
}
